import React from 'react';

export default class Text extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: this.props.value,
      changed: false
    };
    this.intervalId = -1;
  }

  componentDidUpdate(prevProp, prevState){
    if((prevProp.refs !== this.props.refs)){
      if(this.state.changed)
        this.up();
      this.setState({
        changed: false
      })
    }
    if(prevProp.value !== this.props.value){
      this.setState({
        value: this.props.value,
      })
    }
  }


  handleChange = (val) => {
    this.setState({
      value: val,
      changed: true
    }, ()=>{
      this.up();
    })
  }

  onBlur = () => {
    this.up();
  }

  up = () =>{
    if((this.state.changed==true)&&(this.props.callback!=null)){
      this.props.callback({
        field: this.props.name,
        value: this.state.value
      });
      if(this.props.hasOwnProperty('onChange'))
        this.props.onChange();
    }
    this.setState({
      changed: false
    })
  }

  toggleStatus = () => {
    let newVal = !this.state.value
    this.handleChange(newVal);
  }

  render() {
    return (
      <div className="switch-cnt">
        <div className={ (this.state.value==true) ? 'switch switch-checked '+this.state.value : 'switch '+this.state.value } onClick={this.toggleStatus}>
          <span className="switch-slider"></span>
        </div>
        <span>{ (this.state.value==true) ? this.state.positive : this.state.negative }</span>
      </div>
    );
  }
}
